<template>
  <div style="padding-bottom:10px;position:relative;">
    <v-img v-if="profile.avatarUrl" class="profileImage" :src="profile.avatarUrl" @click.stop="showProfileImage=true"></v-img>
    <v-icon v-else style="font-size:10em;margin-left:-0.11em;">mdi-account-box-outline</v-icon>
    <v-tooltip right v-if="profile.premium === true && isPremiumFeatureEnabled()">
      <template v-slot:activator="{ on }">
        <v-icon
          v-on="on"
          class="premium-icon"
          color="var(--v-accent-lighten4)"
          style="font-size:3.5em; margin-left: -1.1em; margin-top: 1.6em;position:absolute;"
        >mdi-star-circle-outline</v-icon>
      </template>
      <span class="lead">Premium</span>
    </v-tooltip>
    <image-dialog
      v-if="showProfileImage"
      :url="profile.avatarUrl"
      :visible="true"
      :closeAction="function() {showProfileImage=false}"
    ></image-dialog>
  </div>
</template>

<script>
import ImageDialog from "@/widgets/ImageDialog"
import envMixin from "@/mixins/envMixin";

export default {
  name: "ProfileAvatar",
  mixins: [envMixin],
  components: {ImageDialog},
  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      showProfileImage: false
    }
  }
};
</script>

<style scoped>
.profileImage {
  width: 8em;
  height: 8em;
  border-radius: 20%;
  margin-right: 1.5em;
  display: inline-block;
}
</style>
